<template>
  <div id="shipping-module-settings">

    <div v-if="cart.delivery.code != null && cart.delivery.code.indexOf('BRANCH') == 0">

      <!-- The customer pickup time plan -->
      <custom-delivery-planning :shopData="shopData" :cart="cart" :code="cart.delivery.code"
          @selected="slotSelected" />

    </div>

    <div class="form-row-inner" v-if="cart.delivery.code == 'MESSANGER'">
      <datepicker :inline="true"></datepicker>
      <br>
      cas vyzvednuti
    </div>

    <div class="form-row-inner" v-if="cart.delivery.code == 'PPL'">
      <!-- TODO -->
    </div>

    <div class="form-row-inner" v-if="cart.delivery.code == 'FEDEX'">
      <!-- TODO -->
    </div>

    <div class="form-row-inner" v-if="cart.delivery.code == 'CP'">
      <!-- TODO -->
    </div>

    <div class="form-row-inner" v-if="cart.delivery.code == 'CP-OB'">
      <!-- TODO -->
    </div>

    <div class="form-row-inner" v-if="cart.delivery.code == 'ZASILK'">
      <!-- TODO -->
    </div>

    <custom-delivery-planning v-if="cart.delivery.code == 'CUSTOM'" :shopData="shopData" :cart="cart" :code="'CUSTOM'"
        @selected="slotSelected" />

  </div>

</template>

<script>

import Utils from '@/utils'
import Datepicker from 'vuejs-datepicker';
import CustomDeliveryPlanning from './shippingMethods/CustomDeliveryPlanning'

export default {
  props: ['cart', 'shopData'],
  components: {
    Datepicker,
    CustomDeliveryPlanning
  },
  data() {
    return {
    }
  },
  created() {
    console.log('ShippingSettings::created', this.cart, this.shopData, this.cart.delivery.code)
    console.log('Available method prices', this.shopData.methodPrices)
  },
  methods: {
    slotSelected() {
      this.$emit('updated');
    },
  }
}

</script>

<style>
</style>
